import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';

export default function Home() {
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const router = useRouter();

  useEffect(() => {
    if (isAuthenticated) {
      router.push('/Home');
    } else {
      router.push('/Login');
    }
  }, [isAuthenticated]);

  return null; // Enquanto a decisão de redirecionamento está sendo tomada, não renderizamos nada ou você pode mostrar um spinner.
}